import React from 'react';
import { Link } from 'react-router-dom';

import './Footer.scss';

class Footer extends React.Component {
  render() {
    return (
      <div className="footer">
        <div className="footer__links">
          <div className="footer__links__section">
            <div className="footer__links__section__header">Support</div>
            <div className="footer__links__link"><a href="mailto:hello@aloha50.com">Contact Us</a></div>
          </div>
          <div className="footer__links__section">
            <div className="footer__links__section__header">About</div>
            <div className="footer__links__link"><Link to="/about/">Our Mission</Link></div>
          </div>
          <div style={{ clear: 'both' }}></div>
        </div>
        <div className="footer__copyright">
          &copy; {new Date().getFullYear()} Aloha50. All rights reserved.
        </div>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/Footer.jsx